import * as React from 'react';
import { useState } from 'react';

import { ReactEditor, useSlate, useSlateStatic } from 'slate-react';

import { AIGenerateIcon } from '@coursera/cds-icons';

import Button, { TOOLBAR_BUTTON_TYPES } from 'bundles/cml/editor/components/buttons/Button';
import AIButtonMenu from 'bundles/cml/editor/components/buttons/ai/AIButtonMenu';
import { isAIButtonDisabled } from 'bundles/cml/editor/components/buttons/ai/utils/aiUtils';
import DropdownIcon from 'bundles/cml/editor/components/icons/DropdownIcon';
import { useFocusedContext } from 'bundles/cml/editor/context/focusContext';

import _t from 'i18n!nls/cml';

const AIButton: React.FC = () => {
  const editor = useSlate();
  const staticEditor = useSlateStatic();
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);
  const { setFocused } = useFocusedContext();

  const handleOpen = (menuOpen: boolean) => {
    if (menuOpen) {
      setFocused(true);
      setOpen(true);
    } else {
      setOpen(false);
      setTimeout(() => {
        setFocused(false);
        ReactEditor.focus(staticEditor);
      }, 250);
    }
  };

  const disabled = isAIButtonDisabled(editor);

  return (
    <div ref={setRef}>
      <Button
        onClick={() => handleOpen(!open)}
        active={open}
        title={_t('AI Tools')}
        disabled={disabled}
        type={TOOLBAR_BUTTON_TYPES.insertion}
      >
        <AIGenerateIcon />
        <DropdownIcon />
      </Button>
      <AIButtonMenu anchorEl={ref || undefined} open={open} onClose={() => handleOpen(false)} />
    </div>
  );
};

export default AIButton;
